import Divider from '@zenbusiness/zui/Divider';
import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { formatNumber } from '#client/utils/currency';

import FieldDetail from './FieldDetail';

export default function FXDetail({ currencyConversion }) {
  if (!currencyConversion || Object.keys(currencyConversion).length === 0) {
    return null;
  }

  const { originalCurrency, amountInOriginalCurrency, fxRate } = currencyConversion;

  const amountInOriginalCurrencyText = amountInOriginalCurrency
    ? `$${formatNumber(amountInOriginalCurrency)}`
    : '';

  return (
    <>
      <Divider />
      <Grid
        columnSpacing="8px"
        container
        pb={{ xs: '24px', md: '56px' }}
        pt={{ xs: '24px', md: '32px' }}
        px={{ xs: '24px', md: '32px' }}
        rowSpacing={{ xs: '16px', md: '32px' }}
      >
        <Grid
          item
          xs={12}
        >
          <Stack
            alignItems="center"
            direction="row"
            justifyContent="space-between"
          >
            <Text
              color="primary"
              size="xl"
              weight="medium"
            >
              FX Details
            </Text>
          </Stack>
        </Grid>
        <FieldDetail
          label="Original Currency"
          value={originalCurrency}
        />
        <FieldDetail
          label="Amount in Original Currency"
          value={amountInOriginalCurrencyText}
        />
        <FieldDetail
          label="FX Rate"
          value={fxRate}
        />
      </Grid>
    </>
  );
}

FXDetail.propTypes = {
  currencyConversion: PropTypes.shape({
    originalCurrency: PropTypes.string,
    amountInOriginalCurrency: PropTypes.number,
    fxRate: PropTypes.string
  })
};
